export default __webpack_public_path__ + "media/images/temporary/standard-pumpkin-329b92126e1d8494bc9d71b85056eb0e.jpg";